var NbAuthStrategyOptions = /** @class */ (function () {
    function NbAuthStrategyOptions() {
    }
    return NbAuthStrategyOptions;
}());
export { NbAuthStrategyOptions };
//# sourceMappingURL=auth-strategy-options.js.map